import { motion } from "framer-motion";
import { AppLayout } from "../../layout/AppLayout";

function World() {
  return (
    <AppLayout bg={"!bg-[#111522]"} noNav={true}>
      <div className="relative pb-14">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 3, delay: 0.4 }}
          className="relative rounded-b-[25px]"
        >
          <img
            className="w-full object-contain rounded-b-[25px]"
            src="/image/church.png"
            alt="banner"
            loading="lazy"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 3, delay: 0.4 }}
          className="px-5"
        >
          <motion.h3
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 2 }}
            className="tracking-tighter text-3xl font-semibold text-white mt-12 mx-0"
          >
            Welcome to Your Worlds
          </motion.h3>
          <button className="mt-10 mb-8 h-[60px] w-full font-semibold text-lg bg-[#FFD700] rounded-[10px] flex items-center justify-center">
            Get Started
          </button>
        </motion.div>
      </div>
    </AppLayout>
  );
}

export default World;
